import React, { Fragment } from 'react'
import classNames from 'classnames'
import { Container } from 'components/shared'
import { APP_NAME } from 'constants/app.constant'
import { PAGE_CONTAINER_GUTTER_X } from 'constants/theme.constant'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
export default function Footer({ pageContainerType }) {
    const navigate = useNavigate()
    const lang = useSelector((state) => state.locale.currentLang)
    const { t } = useTranslation()

    return (
        <section
            className="dw-footer"
            style={{
                backgroundColor: 'transparent',
                backgroundImage:
                    'linear-gradient(90deg, rgb(240, 93, 147) 0%, rgb(248, 212, 36) 100%)',
            }}
        >
            <div className="dw-footer-container">
                <div className="dw-footer-row">
                    <div className="dw-footer-col">
                        <h2>{t('footer:content.Company')}</h2>
                        <div>
                            <h5
                                onClick={() => navigate(`/${lang}/home`)}
                                className="cursor-pointer"
                            >
                                {t('footer:content.Home')}
                            </h5>

                            <h5
                                onClick={() => navigate(`/${lang}/referrals`)}
                                className="cursor-pointer"
                            >
                                {t('footer:content.Referral')}
                            </h5>
                        </div>
                    </div>
                    <div className="dw-footer-col">
                        <h2>{t('footer:content.Support')}</h2>
                        <div>
                            <h5
                                onClick={() => navigate(`/${lang}/contactUs`)}
                                className="cursor-pointer"
                            >
                                {t('footer:content.Contact-Us')}
                            </h5>
                        </div>
                    </div>
                    <div className="dw-footer-col">
                        <h2>{t('footer:content.Legal')}</h2>
                        <div>
                            <h5
                                onClick={() =>
                                    navigate(`/${lang}/privacy-policy`)
                                }
                                className="cursor-pointer"
                            >
                                {t('footer:content.Privacy-Policy')}
                            </h5>
                            <h5
                                onClick={() => navigate(`/${lang}/gdpr`)}
                                className="cursor-pointer"
                            >
                                {t('footer:content.GDPR')}
                            </h5>
                            <h5
                                onClick={() =>
                                    navigate(`/${lang}/terms-and-conditions`)
                                }
                                className="cursor-pointer"
                            >
                                {t('footer:content.Terms-Conditions')}
                            </h5>
                        </div>
                    </div>
                </div>
            </div>
            <h4 className="text-[14px] pt-">{t('footer:content.Copyright')}</h4>
        </section>
    )
}
